export function isArray(value) {
    return Array.isArray(value);
}
export function assertIsArray(value) {
    if (!isArray(value)) {
        throw new TypeError(`Value is not of type array.`);
    }
}
//# sourceMappingURL=array.js.map